import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Address } from './Address';
import { Person } from './Person';
import { Customer } from './Customer';
import { Party } from './Party';
import { Phone } from './Phone';

@supertypeClass({ toClient: true, toServer: true })
export class Grantor extends Persistable(Remoteable(Supertype)) {
  @property({
    rule: ['required'],
    comment: 'The Grantor of the trust is (The Insured, an Individual other than the insured, or an Entity)',
  })
  type: string;

  @property({
    comment: 'Grantor',
  })
  grantorPerson: Person;

  @property({
    rule: ['required', 'TIN'],
    sensitiveData: true,
    comment: 'Taxpayer Identification Number',
  })
  TIN: string;

  @property({ rule: ['EINSSN', 'required'], sensitiveData: true, comment: 'TIN or EIN number' })
  taxId: string;

  @property({ comment: 'TIN or EIN' })
  taxIdType: string;

  @property()
  noTaxId: boolean;

  @property({
    rule: ['required'],
    comment: 'Grantor Entity Name',
  })
  entityName: string;

  @property({
    getType: () => Customer,
    comment: 'Link to Customer table',
  })
  customer: Customer;

  @property({
    getType: () => Party,
    comment: 'Link to Party table',
  })
  party: Party;

  constructor() {
    super();
  }

  static new(customer) {
    return new Grantor().init(customer);
  }

  init(customer) {
    this.customer = customer;

    return this;
  }

  typeTrigger() {
    const PersonClass = Person;

    if (this.type === 'other') {
      this.grantorPerson = PersonClass.new(this.customer);
      this.grantorPerson.residentialAddress = Address.new(this.customer);
      this.grantorPerson.phone = Phone.new(this.customer);
    }
  }

  taxIdTrigger() {
    if (this.taxId) {
      this.noTaxId = false;
      this.setTaxIdType();
    }
  }

  noTaxIdTrigger() {
    if (this.noTaxId) {
      this.taxId = null;
      this.taxIdType = null;
    }
  }

  setTaxIdType() {
    if (this.taxId.charAt(2) === '-') {
      this.taxIdType = 'EIN';
    } else {
      this.taxIdType = 'TIN';
    }
  }
}
